import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { SpinAndHoldCommonConfiguration } from "../../../api";
import { SpinAndHold2Params } from "../SpinAndHold/SpinAndHold2Params";
import { SpinAndHold2_2Screen } from "../SpinAndHold/SpinAndHold2_2Screen";

export class BigSymbolSpinAndHold2_2Screen extends SpinAndHold2_2Screen
{
   
    protected override BonusName(): string
	{
		return "BigSymbolSpinAndHold";
	}

    public constructor(gameResid: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration)
    {
        super(gameResid, params, config);
    }
}


export interface IBigSymbolSpinAndHoldBonusFactory2_2Screen {
	CreateBigSymbolSpinAndHold2_2Screen(gameName: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration): BigSymbolSpinAndHold2_2Screen;
}



export class BigSymbolSpinAndHoldBonusFactory2_2Screen  implements IBigSymbolSpinAndHoldBonusFactory2_2Screen {

	public CreateBigSymbolSpinAndHold2_2Screen(gameName: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration): BigSymbolSpinAndHold2_2Screen {
		return new BigSymbolSpinAndHold2_2Screen(gameName, params, config);
	}
}
